import { useCallback, useEffect, useMemo, useState } from 'react';
import api from '../services/api';

export interface CrecheOption {
  id: number;
  nome: string;
  cnpj: string;
}

export function useCreches() {
  const [creches, setCreches] = useState<CrecheOption[]>([]);

  const carregarCreches = useCallback(async () => {
    try {
      const { data } = await api.get<CrecheOption[]>('/creches');
      setCreches(data || []);
    } catch {
      setCreches([]);
    }
  }, []);

  useEffect(() => {
    carregarCreches();
  }, [carregarCreches]);

  const options = useMemo(
    () => creches.map((c) => ({ value: c.id, label: `${c.nome} (${c.cnpj})` })),
    [creches],
  );

  return { creches, options, carregarCreches };
}
